export enum EAlbumType {
	COMPILATION = 'compilation',
	SINGLE = 'single',
	REMIX = 'remix',
	BUNDLE = 'bundle',
	EP = 'ep',
	MAXISINGLE = 'maxisingle',
	ALBUM = 'album',
}